import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { posts } from '../../api/mockData';
import './index.css';

const PostDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    const foundPost = posts.find(p => p.id === parseInt(id));
    setPost(foundPost);
    
    // 模拟相关文章
    setRelatedPosts(posts.filter(p => p.id !== parseInt(id)));
    
    // 模拟评论数据
    setComments([
      { id: 1, author: '星语者', content: '文章写得真好！期待更多分享！', time: '2小时前' },
      { id: 2, author: '代码猎人', content: '技术细节讲解得很清楚，收藏了！', time: '1天前' },
    ]);
  }, [id]);

  const handleAddComment = () => {
    if (!newComment.trim()) return;
    
    const comment = {
      id: comments.length + 1,
      author: '当前用户',
      content: newComment,
      time: '刚刚'
    };
    
    setComments([comment, ...comments]);
    setNewComment('');
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
  };

  if (!post) {
    return (
      <div className="post-not-found">
        <div className="container">
          <h2>文章未找到</h2>
          <p>返回 <a href="/">首页</a></p>
        </div>
      </div>
    );
  }

  return (
    <div className="post-detail-page">
      <div className="stars-bg"></div>
      
      <div className="container">
        {/* 文章头部 */}
        <article className="post-article">
          <div className="article-header">
            <div className="post-meta">
              <span className="post-category">{post.category}</span>
              <span className="post-date">
                <span className="calendar-icon">📅</span>
                {formatDate(post.date)}
              </span>
            </div>
            
            <h1 className="article-title">{post.title}</h1>
            
            <div className="article-subtitle">
              <div className="author-info">
                <img 
                  src="https://tu.tuhemmei.com/zb_users/upload/2023/06/20230613168661723" 
                  alt="作者" 
                  className="author-avatar"
                />
                <div className="author-details">
                  <span className="author-name">Starrr</span>
                  <span className="post-stats">
                    {post.readTime} · {post.views}次阅读
                  </span>
                </div>
              </div>
              
              <div className="article-tags">
                {post.tags.map((tag, index) => (
                  <span key={index} className="article-tag">#{tag}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="purple-divider"></div>

          {/* 文章内容 */}
          <div className="article-content">
            <div className="content-body">
              <p>{post.content}</p>
              
              <h2>星空下的思考</h2>
              <p>每当夜深人静，仰望星空时，代码就像星辰一样在脑海中闪烁。每一个算法都是宇宙的规律，每一行代码都是探索的脚步。</p>
              
              <blockquote className="quote">
                "代码是思想的星空，每一颗星都是一个可能性的世界。"
              </blockquote>
              
              <h3>技术的深度探索</h3>
              <p>在技术的海洋中航行，需要勇气和智慧。每一次突破都像是发现新的星座，让我们对数字世界有了更深的理解。</p>
              
              <div className="code-example">
                <pre><code>{`// 这是代码示例
const exploreUniverse = () => {
  const stars = ['React', 'Node.js', 'TypeScript'];
  return stars.map(star => \`✨ \${star}\`);
};`}</code></pre>
              </div>
              
              <p>编程不仅仅是一门技术，更是一种艺术。它让我们能够创造、表达、解决问题，在数字世界中留下自己的印记。</p>
            </div>
            
            <div className="article-footer">
              <div className="share-section">
                <span className="share-label">分享到：</span>
                <div className="share-buttons">
                  <button className="share-btn wechat">微信</button>
                  <button className="share-btn weibo">微博</button>
                  <button className="share-btn twitter">Twitter</button>
                </div>
              </div>
              
              <div className="like-section">
                <button className="like-btn">
                  <span className="heart-icon">❤️</span>
                  喜欢 ({post.views})
                </button>
                <button className="bookmark-btn">
                  <span className="bookmark-icon">🔖</span>
                  收藏
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* 评论区域 */}
        <section className="comments-section purple-card">
          <h3 className="comments-title">
            <span className="comment-icon">💬</span>
            评论 ({comments.length})
          </h3>
          
          <div className="comment-form">
            <textarea
              className="comment-input purple-input"
              placeholder="写下你的评论..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              rows="3"
            />
            <div className="comment-actions">
              <button 
                className="purple-btn submit-comment"
                onClick={handleAddComment}
              >
                发表评论
              </button>
            </div>
          </div>
          
          <div className="comments-list">
            {comments.map(comment => (
              <div key={comment.id} className="comment-item">
                <div className="comment-avatar">
                  <div className="avatar-placeholder">
                    {comment.author.charAt(0)}
                  </div>
                </div>
                <div className="comment-content">
                  <div className="comment-header">
                    <span className="comment-author">{comment.author}</span>
                    <span className="comment-time">{comment.time}</span>
                  </div>
                  <p className="comment-text">{comment.content}</p>
                  <div className="comment-actions">
                    <button className="reply-btn">回复</button>
                    <button className="like-comment">点赞</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 相关文章 */}
        {relatedPosts.length > 0 && (
          <section className="related-posts">
            <h3 className="related-title">
              <span className="related-icon">📚</span>
              相关文章
            </h3>
            
            <div className="related-grid">
              {relatedPosts.map(relatedPost => (
                <a 
                  key={relatedPost.id} 
                  href={`/post/${relatedPost.id}`}
                  className="related-card"
                >
                  <h4 className="related-card-title">{relatedPost.title}</h4>
                  <div className="related-card-meta">
                    <span className="related-date">{relatedPost.date}</span>
                    <span className="related-read-time">{relatedPost.readTime}</span>
                  </div>
                </a>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default PostDetail;